import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Footer as FooterContainer,
  FooterContentContainer,
  FooterContent
} from "../styled-components/Footer";
import DeliveryStatus from "../components/DeliveryStatus/";
import { makeGetConfigValue } from "../selectors/config";
import { actions as appActions } from "../actions/app";

const DELIVERY_FEED_FOOTER_HEIGHT = "5rem";

class Footer extends Component {
  componentDidMount() {
    if (
      !this.props.showDeliveryFeed &&
      (!this.props.children || this.props.children.length === 0)
    ) {
      this.props.changeFooterHeight("0rem");
    }
  }

  getHeight = () => {
    const { footerHeight, showDeliveryFeed } = this.props;

    return showDeliveryFeed ? DELIVERY_FEED_FOOTER_HEIGHT : footerHeight;
  };

  render() {
    const { children, showDeliveryFeed } = this.props;
    const height = this.getHeight();
    return (
      <FooterContainer height={height}>
        <FooterContentContainer
          height={height} /* height={height || App.FOOTER_HEIGHT}*/
        >
          {showDeliveryFeed ? (
            <FooterContent>
              <DeliveryStatus />
            </FooterContent>
          ) : null}
          <FooterContent height={height}>{children}</FooterContent>
        </FooterContentContainer>
      </FooterContainer>
    );
  }
}

Footer.defaultProps = {
  children: []
};

Footer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]),
  showDeliveryFeed: PropTypes.bool.isRequired,
  footerHeight: PropTypes.string.isRequired,
  changeFooterHeight: PropTypes.func.isRequired
};

const makeMapStateToProps = () => {
  const getConfigValue = makeGetConfigValue();

  const mapStateToProps = state => ({
    showDeliveryFeed:
      getConfigValue(state, "userConfig", "deliveryFeedDisplay", "hide") ===
      "show",
    footerHeight: state.app.footerHeight
  });

  return mapStateToProps;
};

const mapActionCreators = {
  changeFooterHeight: appActions.changeFooterHeight
};

export default connect(makeMapStateToProps, mapActionCreators)(Footer);



// WEBPACK FOOTER //
// ./app/components/Footer.js